import { Injectable } from "@angular/core";
import * as Sentry from "@sentry/angular";

export interface ErrorReportContext {
  tags?: Record<string, string>;
  extra?: Record<string, unknown>;
}

/**
 * Thin wrapper around the Sentry SDK.
 *
 * Sentry is imported as an ES module namespace, which cannot be spied on in unit tests.
 * Going through an injectable service keeps the reporting of swallowed errors verifiable.
 */
@Injectable({ providedIn: "root" })
export class ErrorReportingService {
  captureException(error: unknown, context?: ErrorReportContext): void {
    Sentry.captureException(error, context);
  }
}
